import { ServerErrorDefaultProps } from '../SessionOutcome/ServerErrorDefaultProps';

export const SessionExpiredDefaultProps = {
  ...ServerErrorDefaultProps,
  icon: 'timeout',
  title: 'Your session has expired',
} as const;
